import Vue from 'vue';
import Router from 'vue-router';
import { WpTelegramForm, WpRefundByOrderInfo, WpByOrderInfo, HDAdmin } from '../components';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Home",
            component: WpByOrderInfo,
            meta: {
                title: "����� �� ����������"
            }
        },
        {
            path: "/",
            name: "Home",
            component: WpTelegramForm,
            meta: {
                title: "����� ����������!"
            }
        },
        {
            path: "/telegram",
            name: "Telegram",
            component: WpTelegramForm,
            meta: {
                title: "��������� ���"
            }
        },
        {
            path: "/orderinfo",
            name: "GetByOrderInfo",
            component: WpByOrderInfo,
            meta: {
                title: "����� �� ����������"
            }
        },
        {
            path: "/order/details",
            name: "GetBySignLink",
            component: WpByOrderInfo,
            meta: {
                title: "����� �� ������"
            }
        }
        ,
        {
            path: "/refund/orderinfo",
            name: "RefundByOrderInfo",
            component: WpRefundByOrderInfo,
            meta: {
                title: "������� �� ����������"
            }
        }
        ,
        {
            path: "/admin",
            name: "Admin",
            component: HDAdmin,
            meta: {
                title: "�����������������",
                requiresAuth: true
            }
        },
    ]
});
